import * as S from './styled'
import { FunctionComponent, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import app from '../../../firebase/initialize'
import { getAuth, signOut } from 'firebase/auth'
import { store } from '../../../redux'
import { CLOSE_HAMBURGER, OPEN_HAMBURGER, RESET, SIGN_OUT } from '../../../redux/misc/types'
import DownloadPDFButton from '../../molecules/DownloadPDFButton'
import { ReactComponent as HamburgerMenu } from '../../atoms/Icons/HamburgerMenu.svg'
import { MainState } from '../../../redux/reducers'
import { useParams } from 'react-router-dom'
import { requestActions } from '../../../redux/requests'
import useConnectRequest from '../../../hooks/useConnectRequest'
import { FETCH_DOCUMENT } from '../../../redux/requests/products/product.actions'
import { Product } from '../../../pages/DashBoard/DashBoardScreen'
type OwnProps = {
  screenName?: string
}

type Props = OwnProps

const Header: FunctionComponent<Props> = ({ screenName }) => {
  const auth = getAuth()
  const userId = auth.currentUser?.uid ?? ''
  const dispatch = useDispatch()
  const { docId } = useParams<{ docId: string }>()

  const username = auth.currentUser?.displayName
  const open = useSelector((state: MainState) => state.misc.openHamburger)
  const product = useSelector((state: MainState) => state.misc.product) as Product

  const handleClick = () => {
    store.dispatch({
      type: open ? CLOSE_HAMBURGER : OPEN_HAMBURGER,
    })
  }
  const { data: doc, loading } = useConnectRequest(FETCH_DOCUMENT, { multiple: false })
  useEffect(() => {
    dispatch(requestActions.products.fetchDocument(userId, docId, product))
    const screenWidth = window.innerWidth
    if (screenWidth < 768) {
      store.dispatch({
        type: CLOSE_HAMBURGER,
      })
    }
  }, [])
  const hasPDF =
    doc && ((doc.hasOwnProperty('hasPDF') && doc.hasPDF) || !doc.hasOwnProperty('hasPDF'))

  return (
    <>
      <S.Header>
        <S.HamburgerMenuStyled onClick={handleClick}>
          <HamburgerMenu />
        </S.HamburgerMenuStyled>
        <S.Wrapper>
          {screenName && <S.ScreenNameStyled>{screenName}</S.ScreenNameStyled>}
          {!loading && doc && <S.ScreenNameStyled> {doc.fileName}</S.ScreenNameStyled>}
          {hasPDF && <DownloadPDFButton docId={docId} />}
        </S.Wrapper>
        <S.UserWrapper>
          <S.User>
            Välkommen <span style={{ color: '#16DBCC' }}>{username}</span>
          </S.User>
          <SignOut />
        </S.UserWrapper>
      </S.Header>
    </>
  )
}

export const SignOut = () => {
  const clickHandler = () => {
    // store.dispatch({ type: 'SET_PRODUCT', product: null })
    signOut(getAuth(app))

    store.dispatch({
      type: RESET,
    })

    store.dispatch({
      type: SIGN_OUT,
    })
  }

  return <S.Button onClick={clickHandler}>Logga ut</S.Button>
}

export default Header
